// Modules
import get from "lodash.get";

/**
 * Compares two elements.
 *
 * @param {String} a the first element to compare
 * @param {String} b the second element to compare
 * @returns the result of local comparison between to elements
 */
export const simpleCompare = (a, b) => {
    return a - b;
};

/**
 * Compares two elements with localCompare.
 *
 * @param {String} a the first element to compare
 * @param {String} b the second element to compare
 * @returns the result of local comparison between to elements using localCompare
 */
export const localCompare = (a, b) => {
    return a?.localeCompare(b);
};

/**
 * Compares to elements by a given field name.
 *
 * @param {String} a the first element to compare
 * @param {String} b the second element to compare
 * @param {String} field the field name to compare the two entries
 * @returns the result of local comparison between to elements
 */
export const sortBy = (a, b, field) => {
    return simpleCompare(get(a, field, undefined), get(b, field, undefined));
};

/**
 * Compares to elements by a given field name using localCompare.
 *
 * @param {String} a the first element to compare
 * @param {String} b the second element to compare
 * @param {String} field the field name to compare the two entries
 * @returns the result of local comparison between to elements
 */
export const sortByLocalCompare = (a, b, field) => {
    return localCompare(get(a, field, undefined), get(b, field, undefined));
};

/**
 * Desceding comparator function.
 *
 * @param {String} a the first element to compare
 * @param {String} b the second element to compare
 * @param {String} orderBy the field name to compare the two entries
 * @returns descending comparation result
 */
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

/**
 * Ascending/Descending comparator.
 *
 * @param {String} order the order (ascending / descending)
 * @param {String} orderBy the field name to compare the two entries
 * @returns the comparator function based on the order
 */
export const getComparator = (order, orderBy) => {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

/**
 * Sorts a list of elements by a comparator.
 *
 * @param {Array} array the list of elements to sort
 * @param {Function} comparator the comparator function
 * @returns the list of elements sorted
 */
export function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}
